import React from "react";

export const RotateIcon = () => {
  return (
    <svg
      aria-hidden={true}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.86091 6.15746C2.00545 6.08831 2.0683 5.98149 2.062 5.80553C2.04315 5.57931 1.78549 5.2651 1.78549 4.42934C1.78549 3.08453 2.6527 2.14192 4.01006 2.14192H4.02891V3.00283C4.02891 3.49928 4.41854 3.6124 4.79558 3.32962L6.51112 2.07907C6.80021 1.87171 6.80021 1.62662 6.51112 1.41298L4.79558 0.156136C4.41224 -0.132979 4.02891 -0.0198052 4.02891 0.489196V1.41298H4.00379C2.20024 1.41298 1 2.6258 1 4.42304C1 5.09543 1.13824 5.64843 1.33306 5.98149C1.43988 6.16374 1.66612 6.25171 1.86091 6.15746ZM11.9783 14C13.0529 14 13.5933 13.4847 13.5933 12.385V6.17001C13.5933 5.07028 13.0529 4.55501 11.9783 4.55501H5.75076C4.67618 4.55501 4.13576 5.07028 4.13576 6.17001V12.385C4.13576 13.4847 4.67618 14 5.75076 14H11.9783ZM11.9594 12.9882H5.76961C5.336 12.9882 5.14748 12.8123 5.14748 12.3661V6.18886C5.14748 5.7427 5.336 5.56674 5.76961 5.56674H11.9594C12.3931 5.56674 12.5815 5.7427 12.5815 6.18886V12.3661C12.5815 12.8123 12.3931 12.9882 11.9594 12.9882Z"
        fill="#666666"
      />
    </svg>
  );
};
